import { SectionDetails } from '@/app/types/marketing/SectionDetails';
import GeneratorLandingPage from '@/components/generator-landing-page/GeneratorLandingPage';
import { ListBulletIcon } from '@heroicons/react/20/solid';
import {
  AcademicCapIcon,
  CircleStackIcon,
  ClipboardDocumentListIcon,
  ClipboardIcon,
  ClockIcon,
  DocumentDuplicateIcon,
  LightBulbIcon
} from '@heroicons/react/24/solid';
import { TableCellsIcon } from '@heroicons/react/24/solid';
import overviewImage from '@/public/wikipedia-overview.png';

const imageSection: SectionDetails = {
  miniText: 'Optimized Studying',
  title: 'Create Flashcards in Seconds from any Wikipedia Article',
  image: overviewImage,
  description:
    'Enhance your learning and retain information effectively by instantly generating flashcards from any Wikipedia article.',
  features: [
    {
      name: 'Search for a wikipedia article',
      description:
        'Simply begin by typing the name of any Wikipedia article. Limbiks uses the article content to generate instant flashcards.',
      icon: ClipboardIcon
    },
    {
      name: 'Select Number of Flashcards',
      description:
        'Specify how many flashcards you need. Whether you need a comprehensive set or just a few key points, Limbiks will prioritize the best flashcards possible.',
      icon: CircleStackIcon
    },
    {
      name: 'Choose Flashcard Types',
      description:
        'Generate various types of flashcards including question-and-answer and fill-in-the-blank. Pick the type that suits your learning style best.',
      icon: TableCellsIcon
    }
  ]
};

const featureSection: SectionDetails = {
  miniText: 'Unlock Knowledge Effortlessly',
  title: 'Transform Wikipedia Articles into Powerful Study Tools',
  description:
    'Our flashcard generator takes Wikipedia articles and converts them into comprehensive flashcard decks, helping you absorb and retain information more efficiently. Leveraging the vast repository of knowledge on Wikipedia, you can master any topic with ease.',
  features: [
    {
      name: 'Instant Practice Tests',
      description:
        'Easily create practice exams from your generated flashcards. Combine multiple flashcard sets from different Wikipedia topics to take a comprehensive exam. Receive detailed score reports and personalized study tips.',
      icon: AcademicCapIcon
    },
    {
      name: 'Efficient Spaced Repetition',
      description:
        'Our advanced spaced repetition system helps you retain information longer by scheduling your study sessions. The system adapts to your strengths and weaknesses, ensuring you review your flashcards at optimal intervals.',
      icon: ClockIcon
    },
    {
      name: 'Contextual Hints and Explanations',
      description:
        'Gain deeper insights with context-specific hints and explanations derived from the original Wikipedia content. This feature helps you reach a thorough understanding of complex subjects when additional help is needed.',
      icon: LightBulbIcon
    }
  ]
};

export default function _YoutubeToFlashcards() {
  return (
    <GeneratorLandingPage
      isWikipedia
      imageSection={imageSection}
      featureSection={featureSection}
      title="Wikipedia to Flashcards"
      description="Paste a link to any YouTube video and generate a comprehensive deck of flashcards in seconds. Learn with our powerful study tools or download flashcards to use with any other flashcard app."
    />
  );
}
